// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__yKC2C","background":"styles_background__wmysU","lines":"styles_lines__oR0Pq"};